module.exports = __WEBPACK_EXTERNAL_MODULE_33__;


/*****************
 ** WEBPACK FOOTER
 ** external "./node/window"
 ** module id = 33
 ** module chunks = 0
 **/